import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const LeaderOfTheWeekCard = ({ leader }) => {
  if (!leader) return null;

  const getSlug = (text) =>
    text?.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-gradient-to-br from-orange-50 via-white to-green-50 border border-orange-200 shadow-xl rounded-2xl p-6 flex flex-col md:flex-row items-center gap-6 mt-12"
    >
      <img
        src={leader.image_url || "/leader-default.png"}
        alt={leader.name}
        className="w-32 h-32 object-cover rounded-full border-4 border-green-500 shadow-md"
        onError={(e) => (e.target.src = "/leader-default.png")}
      />

      <div className="text-center md:text-left flex-1">
        <h3 className="text-xl md:text-2xl font-bold text-orange-700 mb-1">
          🌟 Leader of the Week
        </h3>
        <p className="text-lg font-semibold text-gray-800">{leader.name}</p>
        <p className="text-sm text-gray-600">
          {leader.position} — {leader.constituency}
        </p>
        <p className="text-sm text-blue-700 font-medium mt-1">{leader.party}</p>

        {leader.bio && (
          <p className="text-sm text-gray-600 mt-3 line-clamp-3 italic">
            "{leader.bio}"
          </p>
        )}

        <div className="mt-4">
          <Link
            to={`/constituency/${getSlug(leader.position)}/${getSlug(
              leader.constituency
            )}`}
            className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-full text-sm font-medium shadow"
          >
            View Profile →
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default LeaderOfTheWeekCard;
